import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiLavandierService } from '../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { IArticlePackDetailsList } from '../../../../lib/lib-shared/models/ArticlePack';
import { PRICEMULTIPLIER } from '../../../../lib/lib-shared/defines';
import { ConfirmationModalComponent } from '../../modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'lm-article-pack-list',
  templateUrl: './article-pack-list.component.html',
  styleUrls: ['./article-pack-list.component.scss']
})
export class ArticlePackListComponent implements OnInit {
  public PRICEMULTIPLIER = PRICEMULTIPLIER;

  public articlePackList: IArticlePackDetailsList[] = [];
  public articleNameMap: Map<number, string> = new Map();

  constructor(
    private apiLavandierService: ApiLavandierService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.apiLavandierService.getArticleList()
      .subscribe((articleList: any[]) => {
        this.articleNameMap = new Map(articleList.map(article => [article.id, article.name] as [number, string]));
      });
    this.loadArticlePackList();
  }

  loadArticlePackList() {
    this.apiLavandierService.getArticlePack({})
      .subscribe(articlePackList => this.articlePackList = articlePackList);
  }

  getArticleDescription(articlePack: IArticlePackDetailsList): string {
    return articlePack.articlePackArticleList
      .map(articlePackArticle => {
        const name = this.articleNameMap.get(articlePackArticle.articleId) || `#${articlePackArticle.articleId}`;
        return `${articlePackArticle.quantity / PRICEMULTIPLIER} × ${name}`;
      })
      .join(', ');
  }

  onDelete(articlePack: IArticlePackDetailsList) {
    const confirmationModal = this.modalService.open(ConfirmationModalComponent, {size: 'lg'});
    confirmationModal.componentInstance.confirmationDesc = `Voulez-vous vraiment supprimer le pack ${articlePack.name} ?`;
    confirmationModal.componentInstance.validateButtonText = 'Supprimer';
    confirmationModal.componentInstance.cancelButtonText = 'Annuler';
    confirmationModal.result
      .then(result => {
        if (result) {
          this.apiLavandierService.deleteArticlePackId(articlePack.id, {})
            .subscribe(() => this.loadArticlePackList());
        }
      })
      .catch(() => null);
  }
}
